export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14672.ae5323e5.jpg";